<div class="wk-sm__column__header">
    <div class="wk-sm__column__header-title" kendoTooltip title="" position="bottom" (mouseover)="showTooltip($event)">
        {{ column.Name | wkTranslate }}
    </div>
    <div class="wk-sm__column__header__actions">
        <div class="wk-sm__column__header__actions-button" [id]="'column_' + column.Id">
            <wk-icon-filled-more-sprite-pds3 />
            <icon-pds3 flowClass="target-icon" name="wk-icon-filled-more" />
        </div>

        <dropdown-pds3 cg3-theme="PDS-v3" [targetSelector]="'#column_' + column.Id" menuMode="application" srLabelledby="button2">
            <dropdown-list-pds3 menuMode="application">
                <dropdown-item-field-pds3 (click)="editColumn()" *dropdownListItemPds3>
                    <div>
                        <wk-icon-pencil-sprite-pds3 />
                        <icon-pds3 name="wk-icon-pencil" class="icon-pencil" />
                        <div>{{ "Settings.ReturnCategoriesDropdownOption_Edit" | translate }}</div>
                    </div>
                </dropdown-item-field-pds3>

                <dropdown-item-field-pds3
                    (click)="showDeletePopup(column.Name)"
                    [class.isEmpty]="mappingViewmodel[columnType].length <= 1"
                    *dropdownListItemPds3
                >
                    <div>
                        <wk-icon-trash-sprite-pds3 />
                        <icon-pds3 name="wk-icon-trash" />
                        <div>{{ "General.Delete" | translate }}</div>
                    </div>
                </dropdown-item-field-pds3>
            </dropdown-list-pds3>
        </dropdown-pds3>
    </div>
</div>
<div #scrollContainer>
    <wk-drop-list
        [id]="`${column.Id}-column-statuses`"
        groupId="status"
        [cdkDropListData]="column.Statuses"
        [cdkDropListAutoScrollDisabled]="false"
        cdkDropListOrientation="vertical"
        (drop)="onDrop()"
        class="wk-sm__column__content fancy-scrollbar-newUI"
        [class.wk-sm__column__content-jobs-billing]="isJobsBillingDashboard"
    >
        @for (statusItem of column.Statuses; track statusItem.TaxReturnStatusId) {
            <wk-drag [cdkDragData]="statusItem" [class.wk-drag--jobs-billing]="isJobsBillingDashboard">
                <wk-setting-mapping-status
                    [class.thisIsIE]="thisIsIE"
                    [statusItem]="statusItem"
                    [isJobsBillingDashboard]="isJobsBillingDashboard"
                    (onFormChanged)="onMappingStatusFormChanged($event)"
                />
            </wk-drag>
        }
    </wk-drop-list>
</div>

<ng-template #deleteDialogContent>
    <div class="wk-sm__column__delete-dialog">
        <div class="modal-header wk-sm__column__delete-dialog__header">
            <h3 class="modal-title wk-sm__column__delete-dialog__header-title">{{ "Settings.DeleteStep" | translate }}</h3>
            <wk-icon-filled-close-sprite-pds3 />
            <icon-pds3 name="wk-icon-filled-close" (click)="bsModalRef.hide()" class="wk-sm__column__delete-dialog__header-close" />
        </div>
        <div class="modal-body wk-sm__column__delete-dialog__body">
            <div class="wk-sm__column__delete-dialog__body-heading">
                {{ "Settings.MappingStatusDeleteHeading" | translate }}
            </div>
            <ul>
                <li>
                    {{ stepName }}
                </li>
            </ul>
            <div class="wk-sm__column__delete-dialog__actions">
                <button class="btn-primary wk-sm__column__delete-dialog__actions-delete" (click)="onConfirm(true)">
                    {{ "General.Delete" | translate }}
                </button>
                <button class="btn-secondary wk-sm__column__delete-dialog__actions-cancel" (click)="bsModalRef.hide()">
                    {{ "Settings.btnCancel" | translate }}
                </button>
            </div>
        </div>
    </div>
</ng-template>
